import { useState, useEffect } from "preact/hooks";

export default function useDebounce(value, delay, immediateValues = []) {
  // State and setters for debounced value
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      // Immediate values skip the delay
      if (immediateValues.includes(value)) {
        setDebouncedValue(value);
        return () => {};
      }

      // Update debounced value after delay
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      // Cancel the timeout if value changes (also on delay change or unmount)
      // This is how we prevent debounced value from updating if value is changed ...
      // .. within the delay period. Timeout gets cleared and restarted.
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay, immediateValues] // Only re-call effect if value or delay changes
  );
  return debouncedValue;
}
